import { getCommonCode } from '@src/api/common/code'
import { useCodeStore } from '@src/store/common/codeState'

class CodeInitializationService {
	private static instance: CodeInitializationService;

	static getInstance(): CodeInitializationService {
		if (!CodeInitializationService.instance) {
			CodeInitializationService.instance = new CodeInitializationService();
		}
		return CodeInitializationService.instance;
	}

	// 初始化所有配置数据
	async initializeCodes(): Promise<void> {
		try {
			const response = await getCommonCode();
			if (response.code === 200) {
				useCodeStore.getState().setAllCodes(response.data);
			} else {
				throw new Error(response.msg || '获取配置数据失败');
			}
		} catch (error) {
			console.error('初始化配置数据失败:', error);
			// 可以考虑降级方案，如使用默认配置
			throw error;
		}
	}

	// 检查是否已完成初始化
	isInitialized(): boolean {
		return useCodeStore.getState().initialized;
	}
	getCodeByType(codeType:string){
		return useCodeStore.getState().getOptionsByType(codeType);
	}

	// 清空配置数据
	clearCodes(): void {
		useCodeStore.getState().clear();
	}
	// 定期刷新配置（可选）
	startAutoRefresh(intervalMs: number = 30 * 60 * 1000) { // 默认30分钟
		const refresh = async () => {
			try {
				await this.initializeCodes();
			} catch (error) {
				console.error('自动刷新配置失败:', error);
			}
		};

		const intervalId = setInterval(refresh, intervalMs);
		return () => clearInterval(intervalId);
	}
}

export default CodeInitializationService.getInstance();
